export default "__VITE_ASSET__2hqSdsWv__"